module.exports = __webpack_public_path__ + "vue-app/img/big-2.6b2c5d20.jpg";